// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__2cKIS","more":"styles_more__32bii"};